// extracted by css-extract-rspack-plugin
export default {"sectionHeader":"sectionHeader-jfxr6B","administrationGrid":"administrationGrid-LQ1Q9l"};